module.exports = __webpack_public_path__ + "img/qysj_bg1.fa6ddfdf.png";